export function toBRL(value = 0) {
  return parseFloat(value).toLocaleString(
    'pt-br', { minimumFractionDigits: 2 }
  );
}
